// BuiltIn Imports

import { createRef } from 'react';

var map = new Map();

var setRef = function setRef(key) {
  if (!key) return console.warn('useDynamicRefs: Cannot set ref without key ');
  var ref = createRef();
  map.set(key, ref);
  return ref;
};

var getRef = function getRef(key) {
  if (!key) return console.warn('useDynamicRefs: Cannot get ref without key');
  return map.get(key);
};

var useDynamicRefs = function useDynamicRefs() {
  return [getRef, setRef];
};

export default useDynamicRefs;
//# sourceMappingURL=index.js.map
